import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudittrayComponent } from './component/audittray/audittray.component';
import { AudittrayContainerComponent } from './containers/audittray-container/audittray-container.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AudittrayRoutingModule } from './audittray-routing-module';
import { GatewayFacade } from '../../../gateway/src/lib/states/+gateway/gateway.facades';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, AudittrayRoutingModule, EpimsDashboardNavModule],
  declarations: [AudittrayComponent, AudittrayContainerComponent],
  providers: [GatewayFacade]
})
export class AudittrayModule {}

